import { buildModelManager } from "../builder.js";
const DefaultAgentConfigurationSelection = {
  __typename: true,
  id: true,
  capabilities: true,
  contextAuthorizedUsers: true,
  contextEnabled: true,
  contextFeatures: true,
  createdAt: true,
  createdById: true,
  description: true,
  enabledTools: true,
  guardrailSettings: true,
  initiatorMessage: { markdown: true, truncatedHTML: true },
  instructions: { markdown: true, truncatedHTML: true },
  isActive: true,
  lastModifiedById: true,
  modelSettings: true,
  name: true,
  outputFormats: true,
  sdkGenerated: true,
  secretFeatures: true,
  toolsEnabled: true,
  updatedAt: true,
  vectorStoreId: true,
  version: true
};
const modelApiIdentifier = "agentConfiguration";
const pluralModelApiIdentifier = "agentConfigurations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByName",
    findByField: "name",
    findByVariableName: "name",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByName",
    findByField: "name",
    findByVariableName: "name",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConfigurationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAgentConfiguration",
    operationReturnType: "CreateAgentConfiguration",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      agentConfiguration: { required: false, type: "CreateAgentConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAgentConfigurations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAgentConfigurationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentConfigurationSelection
  },
  {
    type: "action",
    operationName: "updateAgentConfiguration",
    operationReturnType: "UpdateAgentConfiguration",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      agentConfiguration: { required: false, type: "UpdateAgentConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAgentConfigurations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAgentConfigurationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentConfigurationSelection
  },
  {
    type: "action",
    operationName: "deleteAgentConfiguration",
    operationReturnType: "DeleteAgentConfiguration",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAgentConfigurations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAgentConfiguration",
    operationReturnType: "UpsertAgentConfiguration",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      agentConfiguration: { required: false, type: "UpsertAgentConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAgentConfigurationResult": { hasReturnType: false },
      "... on UpdateAgentConfigurationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAgentConfigurations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAgentConfigurationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAgentConfigurationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "agentConfigurationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AgentConfigurationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAgentConfigurationSelection,
  operations
);
export {
  AgentConfigurationManager,
  DefaultAgentConfigurationSelection
};
//# sourceMappingURL=AgentConfiguration.js.map
